import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Component } from '@angular/core';
import { FirebaseEmulatorsService } from 'src/app/services/firebase-emulators.service';
import { PlatformLocation } from '@angular/common';
import { NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { disableAnalyticsOnTokenPageNavigation } from 'src/app/v2/components/public/complete-waivers/complete-waivers-analytics-guard';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'fleet-adventures';

  constructor (
    private afFun: AngularFireFunctions,
    private afFire: AngularFirestore,
    private afStore: AngularFireStorage,
    private fsEmulatorService: FirebaseEmulatorsService,
    private location: PlatformLocation,
    router: Router,
  ) {
    // In-app navigation into a token-bearing waiver page must not reach
    // analytics either (main.ts covers page loads that start there).
    disableAnalyticsOnTokenPageNavigation(
      router.events.pipe(filter((event): event is NavigationStart => event instanceof NavigationStart)),
      window as unknown as Record<string, unknown>,
      environment.firebase?.measurementId,
    );

    this.fsEmulatorService.useEmulators({
      afFunctions: this.afFun,
      afFirestore: this.afFire,
      afStorage: this.afStore
    })

    location.onPopState(()=>{
      $('.modal').modal('hide');
    })
  }
}
